import { Grid, Paper } from "@mui/material";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";

import AuthPageLayout from "../layout/AuthPageLayout";
import LoadingIndicator from "../components/common/LoadingSpinner";
import { useUserAPI } from "../context/userAPIContext";
import { CustomToolbar } from "../components/common/CustomDataGridToolBar";
import { CustomModal } from "../components/common/CustomModal";
import { ADMIN_ROLE } from "../utils/constants";
import { getTeams, postTeam } from "../services/api/teams";

const createTeamModalProps = { 
  title: 'Create Skill',
  description:
    'Backend response to create skill:',
  confirmButtonText: 'Create',
  cancelButtonText: 'Cancel',
  confirmButtonColor: 'primary',
  variant: 'outlined',
};

export const Teams = () => {

  const teamsTableColumns = [
    {
      field: 'name',
      headerName: 'NAME',
      minWidth: 150,
      flex: 1,
      headerClassName: 'header-style',
      headerAlign: 'center'
    }
  ];

  const isAdmin = () => user.roles.demo && user.roles.demo.includes(ADMIN_ROLE);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [teams, setTeams] = useState([]);
  const { user, checkUserAuthentication } = useUserAPI();
  const [ messageCreate, setMessageCreate] = useState('');

  const createTeam = async () => {
    setOpenCreateModal(true)
    const message = await postTeam();
    setMessageCreate(message);
  };

  useEffect(() => {
    checkUserAuthentication();
    const fetchTeams = async () => {
      setIsLoading(true);
      const fetchedTeams = await getTeams();
      setTeams(fetchedTeams);
      setIsLoading(false);
    };

    fetchTeams();
    // eslint-disable-next-line
  }, []);


  return (
    <>
      <AuthPageLayout containerWidth='lg'>
        <Grid container direction="column">
            <Paper
              sx={{
                p: 5,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <Typography variant="h6" sx={{paddingBottom:1, fontWeight:"bold"}}>
                Teams
              </Typography>
              {
                isLoading ?
                (<LoadingIndicator />) :
                (
                  <div style={{ height: 390, width: '100%' }}>
                    <div style={{ display: 'flex', height: '100%' }}>
                      <div style={{ flexGrow: 1 }}>
                        <DataGrid
                          {...(isAdmin() ? {components: { Toolbar: () => <CustomToolbar addAction={createTeam}/> }}: {})}
                          sx={{ fontSize: 18, '& .header-style': {
                            fontSize: 18,
                          },}}
                          rows={teams}
                          columns={teamsTableColumns}
                          getRowId={(team) => team.id}
                          pageSize={10}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          disableColumnResize={false}
                          checkboxSelection={false}
                          autoPageSize={true}
                          getRowHeight={() => 'auto'}
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            </Paper>
          </Grid>
          <CustomModal
          {...createTeamModalProps}
          open={openCreateModal}
          handleClose={() => setOpenCreateModal(false)}
          handleConfirm={() => setOpenCreateModal(false)}
          handleCancel={() => setOpenCreateModal(false)}
          children={<h1>{messageCreate}</h1>}
        />
      </AuthPageLayout>
    </>
  )
};
